import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList, TemplateRef, ElementRef } from '@angular/core';
import { CollapseTemplateDirective } from 'src/app/shared/collapse/collapse-template.directive';

@Component({
  selector: 'app-collapse',
  templateUrl: './collapse.component.html',
  styleUrls: ['./collapse.component.scss']
})
export class CollapseComponent implements OnInit, AfterContentInit {
  @ContentChildren(CollapseTemplateDirective) templates: QueryList<CollapseTemplateDirective>;
  @Input() collapse = false;
  @Output() onExpanded: EventEmitter<any> = new EventEmitter();
  @Output() onCollapsed: EventEmitter<any> = new EventEmitter();
  contentHeadTemplate: TemplateRef<any>;
  contentBodyTemplate: TemplateRef<any>;
  private _event: 'collapsed' | 'collapses' | 'expanded' | 'expands' = 'collapsed';

  constructor(private selfElemRef: ElementRef<HTMLElement>) { }

  get isCollapsed(): boolean {
    return this.collapse === false;
  }

  get isExpanded(): boolean {
    return this.collapse === true;
  }

  ngOnInit() {
    // this.collapse = true;
  }

  ngAfterContentInit(): void {
    this.templates.forEach(item => {
      if (item.getType() == 'contentHead') {
        this.contentHeadTemplate = item.template;
      } else {
        this.contentBodyTemplate = item.template;
      }
    });
  }

  toggleCollapse() {
    this.collapse = !this.collapse;
    if (this.isCollapsed) {
      this.onCollapsed.emit();
    } else if (this.isExpanded) {
      this.onExpanded.emit();
    }
  }

  sendEvent(event: 'collapses' | 'expands' )
  {
    this._event = event;
  }

  collapsed() {
    if (this.collapse) {
      this.collapse = false;
    }
  }

  expanded() {
    if (!this.collapse) {
      this.collapse = true;
    }
  }

    get isCurrentEventCollapes(){
        return this._event === 'collapses';
    }
}
